module.exports = {"TXTCLI_LoadingXX":{"id":"TXTCLI_LoadingXX","defaultMessage":"Загрузка...","flags":["TRACK"],"track":"Loading..."}}